import { IconPhone } from '@leland-dev/leland-ui-library';

const ScheduleACallSection = () => {
  return (
    <div className="mt-3 rounded-xl bg-leland-gray-hover p-5">
      <h3 className="font-medium text-leland-gray-dark">
        Talk to a team member
      </h3>
      <p className="text-base text-leland-gray-light">
        Schedule a call with a Leland team member who can help you explore your
        options.
      </p>
      <a
        href="https://calendly.com/d/4cs-hhf-zsx/meet-with-the-leland-team"
        target="_blank"
      >
        <div className="mt-2 flex items-center gap-2">
          <IconPhone className="size-4 text-leland-primary" />
          <p className="text-leland-primary underline">Schedule a call</p>
        </div>
      </a>
    </div>
  );
};

export default ScheduleACallSection;
